import React from 'react';
import PropTypes from 'prop-types';
import PurchaseLimitItem from "./purchase_limit_item";

class PurchaseLimitIndex extends React.Component {
  //setup
  constructor(props) {
    super(props);
  }

  //getters


  //actions


  //render
  render() {
    const {decimalPlaces} = this.props;

    return (
      <div className="purchase-limit-index"
           style={{
             paddingBottom: 25
           }}
      >
        <div style={{
          display: "flex",
          overflowY: "auto",
          flexDirection: "column",
          alignItems: "center",
        }}
        >
          {this.emptyState()}
        {
          this.props.limits.map((l, idx) =>
            <PurchaseLimitItem
              key={idx}
              limitAmountUnit={l.limitAmountUnit}
              total={l.total}
              limit={l.limit}
              name={l.name}
              decimalPlaces={decimalPlaces}
            />
          )
        }
        </div>
      </div>
    )
  }

  isEmpty() {
    return !this.props.limits || this.props.limits.length === 0
  }
  emptyState(){
    if (this.isEmpty()){
      return <h4> No Limits Have been Created </h4>;
    }
  }
}

PurchaseLimitIndex.propTypes = {
  limits: PropTypes.array.isRequired,
  decimalPlaces: PropTypes.number.isRequired,
};

export default PurchaseLimitIndex;



// WEBPACK FOOTER //
// ./src/components/purchase_limits/purchase_limit_index.jsx